import { PropsWithChildren } from 'react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';
import SearchIcon from '@icons/inputs/search_icon.svg?component';
import ChevronIcon from '@icons/inputs/chevron_icon.svg?component';

export function getDropdownIndicator<T>(
  props: PropsWithChildren<DropdownIndicatorProps<T, boolean, GroupBase<T>>>,
  isSearchSelect: boolean
): JSX.Element | null {
  if (props.isDisabled) return null;
  const style = ` w-[24px] h-[24px] opacity-30 group-hover:!opacity-100 ${
    props.isFocused && '!opacity-100'
  }`;
  return (
    <components.DropdownIndicator {...props}>
      {isSearchSelect ? <SearchIcon className={style} /> : <ChevronIcon className={style} />}
    </components.DropdownIndicator>
  );
}
